import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import AuthAxios from "../../config/authAxios";
import apiRoutes from "../apiConfigs";

export const channeltypeDeleteApi = createAsyncThunk(
  "auth/channeltype/delete",
  async (id, { rejectWithValue }) => {
    try {
      const response = await AuthAxios.delete(apiRoutes.channelTypeAction('delete',1,id,1));
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

const channeltypeDeleteSlice = createSlice({
  name: "channeltype delete",
  initialState: { result: [], loading: false, error: null, message: "" },
  extraReducers: (builder) => {
    builder.addCase(channeltypeDeleteApi.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(channeltypeDeleteApi.fulfilled, (state, action) => {
      state.loading = false;
      state.result = action?.payload?.result;
      state.message = action?.payload?.message;
    });
    builder.addCase(channeltypeDeleteApi.rejected, (state, action) => {
      state.loading = false;
      state.error = action?.payload?.error;
      state.message = action?.payload?.message;
    });
  },
});

export const channeltypeDeleteReducer = channeltypeDeleteSlice.reducer;
